<template>
  <v-container>
    <v-card>
      <v-tabs color="primary">
        <v-tab>{{ $t("comments.executive") }}</v-tab>
        <v-tab>{{ $t("comments.events") }}</v-tab>
        <v-tab>{{ $t("comments.comments") }}</v-tab>
        <v-tab-item>
          <v-container fluid>
            <v-textarea auto-grow outlined v-model="commExecutive.comments" readonly></v-textarea>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <v-textarea auto-grow outlined v-model="commEvent.summary" readonly></v-textarea>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <v-textarea auto-grow outlined v-model="comm.comments" readonly>
              <template v-slot:label>
                {{ $t("comments.mm") }}
              </template>
            </v-textarea>
          </v-container>
          
          <!-- <v-container fluid>
            <v-textarea auto-grow outlined v-model="comm.clicomments" readonly>
              <template v-slot:label>
                {{ $t("comments.nn") }}
              </template>
            </v-textarea>
          </v-container> -->

          <v-container fluid v-for="comment in signatureComments" :key="comment.id">
            <v-textarea auto-grow outlined :value="comment.cliComment" readonly>
              <template v-slot:label>
                {{ $t("comments.nn") + " : " + comment.name + "" }}
              </template>
            </v-textarea>
          </v-container>
          <!--   <v-container fluid>
            <v-textarea auto-grow outlined v-model="comm.ffcomments" readonly>
              <template v-slot:label>
                {{ $t("comments.ee") }}
              </template>
            </v-textarea>
          </v-container> -->
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      commExecutive: { comments: "" },
      commEvent: { summary: "" },
      comm: { comments: "", clicomments: "" },
      signatureComments: [],

      currentMainDprId: null,
      currentPVId: null,
    };
  },
  computed: {
    ...mapGetters(["mv_comment/getComments", "mv_commentEvent/getEventComments", "mv_commentExecutive/getExecutiveComments", "mv_dprData/getDprPVId", "mv_dprData/getCurrentDprMainId", "mv_dprHeader/getDprHeader"]),

    comments() {
      let entities = this["mv_comment/getComments"] || [];
      return entities.length > 0 ? entities[0] : {};
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  created() {
    this.currentMainDprId = this.$route.params.dprMainId;
    this.currentPVId = this.$route.params.pvId;
    this.reset();
  },

  methods: {
    ...mapMutations(["mHideLongLoader"]),
    ...mapActions(["mv_comment/fetchComments", "mv_commentEvent/fetchComments", "mv_commentExecutive/fetchComments", "mv_comment/fetchSignatureComments"]),

    refreshCommentsExecutive() {
      this["mv_commentExecutive/fetchComments"](this.currentMainDprId).then((entities) => (this.commExecutive = entities[0] || this.commExecutive));
    },

    refreshCommentsEvents() {
      this["mv_commentEvent/fetchComments"](this.currentMainDprId).then((entities) => (this.commEvent = entities[0] || this.commEvent));
    },

    refreshComments() {
      this["mv_comment/fetchComments"](this.currentMainDprId).then((entity) => this.initComment(entity[0]));
    },

    refreshSignatureComments() {
      this["mv_comment/fetchSignatureComments"](this["mv_dprHeader/getDprHeader"].dprFileId).then((entity) => {
        this.signatureComments = entity.filter((e) => e.cliComment);
      });
    },

    reset() {
      this.refreshCommentsExecutive();
      this.refreshCommentsEvents();
      this.refreshComments();
      this.refreshSignatureComments();
    },

    initComment(comment) {
      this.comm = comment ? comment : "";
    },
  },
};
</script>
<style scoped>
.container {
  max-width: 95%;
}
</style>
